module.exports = __webpack_public_path__ + "img/team-engineering.cae1d69f.svg";